import { render, staticRenderFns } from "./Soya.vue?vue&type=template&id=264e01d3&"
import script from "./Soya.vue?vue&type=script&lang=js&"
export * from "./Soya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports